import React from 'react';
import { WebsiteDesignProps } from './types';
import { Candy, HeartHandshake, Smile } from 'lucide-react';
import { Button } from "@/components/ui/button";

const CandyLand: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Sweet Tooth Academy";

    return (
        <div className="bg-[#fff0f6] min-h-screen font-sans text-[#d63384]">
            <nav className="p-6 flex justify-between items-center bg-white/50 backdrop-blur border-b-4 border-[#ffec99]">
                <div className="flex items-center gap-2 text-3xl font-black tracking-tight text-[#ff6b6b] drop-shadow-sm">
                    <Candy className="fill-[#ff6b6b]" /> {schoolName}
                </div>
                <Button className="rounded-full bg-[#ff6b6b] hover:bg-[#fa5252] text-white font-bold border-4 border-[#ffc9c9] shadow-lg">
                    Yummy!
                </Button>
            </nav>

            <main className="container mx-auto px-6 py-16 text-center">
                 <div className="bg-white p-12 rounded-[3rem] shadow-[8px_8px_0_#ffdeeb] border-4 border-[#ffdeeb] inline-block mb-16 max-w-4xl">
                     <h1 className="text-6xl md:text-8xl font-black mb-6 text-transparent bg-clip-text bg-gradient-to-r from-[#ff6b6b] via-[#fab005] to-[#4c6ef5] leading-tight">
                         A Treat <br/> For The Mind
                     </h1>
                     <p className="text-xl text-[#868e96] font-bold max-w-xl mx-auto mb-8">
                         Learning is sweet! We make education as delightful as your favorite dessert.
                     </p>
                     
                     <div className="grid grid-cols-3 gap-4 max-w-lg mx-auto">
                         <div className="h-4 bg-[#ff6b6b] rounded-full"></div>
                         <div className="h-4 bg-[#fab005] rounded-full"></div>
                         <div className="h-4 bg-[#4c6ef5] rounded-full"></div>
                     </div>
                 </div>

                 <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                     <div className="bg-[#e3fafc] p-8 rounded-3xl border-4 border-[#99e9f2] shadow-[6px_6px_0_#99e9f2] transform hover:-translate-y-2 transition-transform">
                         <Smile size={48} className="mx-auto mb-4 text-[#22b8cf]" />
                         <h3 className="text-2xl font-black text-[#1098ad] mb-2">Fun</h3>
                         <p className="text-[#0c8599] font-medium">Laughter in every lesson.</p>
                     </div>
                     <div className="bg-[#fff9db] p-8 rounded-3xl border-4 border-[#ffec99] shadow-[6px_6px_0_#ffec99] transform hover:-translate-y-2 transition-transform">
                         <HeartHandshake size={48} className="mx-auto mb-4 text-[#fcc419]" />
                         <h3 className="text-2xl font-black text-[#f08c00] mb-2">Friends</h3>
                         <p className="text-[#e67700] font-medium">Making lasting connections.</p>
                     </div>
                     <div className="bg-[#f3d9fa] p-8 rounded-3xl border-4 border-[#eebefa] shadow-[6px_6px_0_#eebefa] transform hover:-translate-y-2 transition-transform">
                         <Candy size={48} className="mx-auto mb-4 text-[#be4bdb]" />
                         <h3 className="text-2xl font-black text-[#9c36b5] mb-2">Growth</h3>
                         <p className="text-[#862e9c] font-medium">Getting smarter every day.</p>
                     </div>
                 </div>
            </main>
        </div>
    );
};

export default CandyLand;
